import React, { useEffect } from 'react';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const TooltipButton = ({ tooltipTitle, tooltipContent, children }) => {
    useEffect(() => {
        // Select the button element
        const tooltipButton = document.querySelector('.tooltip-button');

        // Initialize the tooltip
        const tooltipInstance = new Tooltip(tooltipButton, {
            title: tooltipContent,
            trigger: 'hover',
            html: true,
            customClass: 'tooltip-success',
        });

        // Cleanup tooltip when the component unmounts
        return () => {
            tooltipInstance.dispose();
        };
    }, [tooltipContent]); // Include tooltipContent in the dependency array

    return (
        <div>
            <button
                type="button"
                className="tooltip-button text-success-600"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
            >
                {children}
            </button>
            <div className="my-tooltip tip-content hidden text-start shadow">
                <h6 className="text-white">{tooltipTitle}</h6>
                <p className="text-white">{tooltipContent}</p>
            </div>
        </div>
    );
};

export default TooltipButton;